import axios from 'axios';
import { getToken } from '../../helpers';

export const defaultParams = () => ({
  //Bearer token is injected after authentication
});

export default axios;
